
import type { LocationQuery } from 'vue-router';

import {
  type PaginationParams,
  getPaginationFromQuery,
  getPaginationToQuery,
} from '../pagination/functions';

export interface SearchParams extends PaginationParams {
  search?: string;
}

export function getSearchFromQuery(query: LocationQuery): SearchParams {
  const { search } = query;

  return {
    search: search ? search.toString() : undefined,
    ...getPaginationFromQuery(query),
  };
}

export const getSearchToQuery = (params: SearchParams): SearchParams => {
  const pagination = getPaginationToQuery(params);
  if (params.search && params.search.trim().length > 0) {
    return {
      ...pagination,
      search: params.search,
    };
  }
  return pagination;
};
